import React, { useState, useEffect } from 'react'
import classes from './Signup.module.css'
import { motion } from 'framer-motion'
import { db } from '.././firebaseConfig'
import { useAuth } from '../Context/AuthContext'
import { useHistory } from 'react-router-dom'
import { CircularProgress } from '@material-ui/core'

function Signup({ showSignin }) {
    const history = useHistory();
    const { signup, setLoggedIn } = useAuth();

    const [userName, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [email, setEmail] = useState('');
    const [bio, setBio] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setUsername('');
        setEmail('')
        setPassword('')
        setBio('')
        setError('')
    }, [])
    async function submitHandler(e) {
        let id;
        e.preventDefault()
        if (!email || !bio || !userName || !password) {
            return setError("Fill the whole form to proceed");
        }

        try {
            setLoading(true)
            await signup(email, password).then(
                (user) => {

                    id = user.user.uid;
                    return user.user.updateProfile({
                        displayName: userName
                    })
                }
            ).then(() => {
                return db.collection('users').doc(id).set({
                    name: userName,
                    email: email,
                    status: bio
                })
            })
                .then(() => {

                    alert("Account created succesfully");

                    setLoggedIn(false);
                    history.push("/login")






                }).catch(error => {
                    alert(error)
                })
        }
        catch {
            setError("failed to create account")
        }
        setLoading(false)
    }
    const goToDashboard = () => {
        history.push("/")
    }




    return (

        <motion.form className={classes.form} initial={{ y: "-100vh", x: "-100vh" }}
            animate={{ y: "-50%", x: "-50%" }} onSubmit={submitHandler}>

            <div className={classes.header}>
                <h1>Sign Up</h1>
                <button className={classes.close} onClick={goToDashboard}>X</button>
            </div>
            {error && <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className={classes.error}>{error}</motion.div>}
            {loading && <CircularProgress className={classes.progress} />}
            <label htmlFor="username">Username</label>
            <input type="text" id="username" placeholder="Username" onChange={(e) => setUsername(e.target.value)} />
            <label htmlFor="email">Email</label>
            <input type="email" id="email" placeholder="Email" onChange={(e) => setEmail(e.target.value)} />
            <label htmlFor="password">Password</label>
            <input type="password" id="password" placeholder="Password" onChange={(e) => setPassword(e.target.value)} />
            <label htmlFor="text">Bio</label>
            <input type="text" id="bio" placeholder="Bio" onChange={(e) => setBio(e.target.value)} />
            <button type="submit" disabled={loading} className={classes.submit} >Submit</button>
        </motion.form>
    )
}

export default Signup
